import { DefaultTheme, ThemedStyledProps } from 'styled-components';
import { LiteralUnion } from 'type-fest';

export type Space = LiteralUnion<'small' | 'medium' | 'large', string | number>;

export interface Spaceable {
  /**
   * The amount of space between elements.  Values of "small", "medium", and
   * "large" are based on the default theme spacing.  If `space` is a number,
   * it is multiplied by the theme's default spacing value.  If `space` is a string,
   * it is used as-is and applied direction to the element in question.
   */
  space?: Space;
}

export interface SpaceableStyle {
  $space: Space;
}

function getSpaceMultiplier(space: Space) {
  if (typeof space === 'number') {
    return space;
  }

  switch (space) {
    case 'small':
      return 1;

    case 'medium':
      return 2;

    case 'large':
      return 3;

    default:
      return space;
  }
}

export function getSpacing(
  props: ThemedStyledProps<SpaceableStyle, DefaultTheme>,
): string {
  const { $space, theme } = props;
  const multiplier = getSpaceMultiplier($space);

  if (typeof multiplier === 'string') {
    return multiplier;
  }

  return `${multiplier * theme.spacing.base}px`;
}
